// extracted by mini-css-extract-plugin
export default {"content":"styles__content___P2iBH","modal-in":"styles__modal-in___cgHVd","textContent":"styles__textContent___XubzO","buttonContent":"styles__buttonContent___lZHwT"};